// extracted by mini-css-extract-plugin
export default {"container":"terms_of_service___container___be208e25"};